export class Constants {
    public static tinyMceSettings = {
        skin_url: '/assets/tinymce/skins/ui/oxide',
        content_url: '/assets/tinymce/skins/content/default',
        inline: false,
        relative_urls: false,
        statusbar: false,
        browser_spellcheck: true,
        fontsize_formats: '12px 13px 14px 16px 18px 20px',
        // tslint:disable-next-line:max-line-length
        toolbar: 'undo redo | styleselect | fontselect | fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | removeformat | bullist numlist startBtn outdent indent | link imageBtn | table tabledelete',
        plugins: 'fullscreen, lists, advlist, link, table',
        // tslint:disable-next-line: max-line-length
        // content_css: ['https://fonts.googleapis.com/css?family=Andika|Mukta+Malar:300,400,500|Noto+Sans|Roboto:300,400,500&display=swap'],
        // tslint:disable-next-line: max-line-length
        // font_formats: 'Roboto = Roboto, sans-serif; Andika = Andika, sans-serif; Mukta Malar = Mukta Malar, sans-serif; Noto Sans = Noto Sans, sans-serif;',
        // body_class: 'desktop',
        invalid_styles: {
            'table': 'width height',
            'tr': 'width height',
            'th': 'height',
            'td': 'width height'
        },
        // setup: (editor) => {
        //     editor.ui.registry.addButton('imageBtn', {
        //         text: '',
        //         icon: 'image',
        //         onAction: () => {
        //             this.openModal(editor);
        //         }
        //     });
        // }
    };
}
export const BasePath = '/webapp/';
// export const BasePath = '/alpha/';
// export const BasePath = '/beta/';
// export const BasePath = '';
// export const EmailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
export const EmailPattern = '^\S+@\S+$';

// cmd line Change Current Date Time On Login Screen Bottom
// cmd line ng build --prod --base-href=/webapp/;
// cmd line npm run ng-high-memory